import { OrganizationListItem } from './types';
import { useGetOrganizationCollectionEndpoint } from './useGetOrganizationCollectionEndpoint';

/**
 * Lista organizacji dla InMail. Realtime z client SDK zastąpiony tym samym
 * endpointem v3 co tabela ACS — po zapisie i tak invalidujemy cache.
 */
export const useGetOrganizationsRealtime = () => {
  const query = useGetOrganizationCollectionEndpoint();
  return {
    organizations: (query.data ?? []) as OrganizationListItem[],
    isLoading: query.isLoading,
    error: query.error as Error | null,
  };
};
